import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    Grid,
    CircularProgress,
    TextField,
    Button,
    FormControlLabel,
    Checkbox
} from '@material-ui/core';
import { ErrorIcon } from '../../../icons';

import { useNotify } from '../../../hooks/useNotify';
import { doSwaggerCall, useSwaggerClient } from '../../../hooks/useSwaggerClient';
import AdminHeader from '../../../components/atom/AdminHeader';
import { useHistory } from 'react-router';
import FormSection from '../../../components/atom/FormSection';

function CancelReasonsEditPage() {
    const { cancelReasonId } = useParams();
    const { notifyError, notifySuccess } = useNotify();
    const history = useHistory();
    const [cancelReason, loading, error, setCancelReason] = useSwaggerClient('cancelreasons', 'getCancelReason', {
        cancelReasonId: parseInt(cancelReasonId, 10)
    });

    const modifyCancelReason = () => {
        doSwaggerCall('cancelreasons', 'updateCancelReason', {
            cancelReason: {
                name: cancelReason.name,
                description: cancelReason.description,
                requires_note: cancelReason.requires_note
            },
            cancelReasonId: parseInt(cancelReasonId, 10)
        })
            .then(newCancelReason => {
                setCancelReason(newCancelReason);
                notifySuccess('Cancel reason modified!');
                history.push(`/admin/cancelreasons`);
            })
            .catch(err => {
                console.log(err);
                notifyError('Could not modify cancel reason!');
            });
    };

    if (error) {
        return (
            <Grid container justifyContent="center">
                <h1>{error}</h1>
            </Grid>
        );
    }
    if (loading) {
        return (
            <Grid container justifyContent="center">
                <CircularProgress />
            </Grid>
        );
    }

    return (
        <Grid className="bg-white activity-edit">
            <form
                onSubmit={ev => {
                    ev.preventDefault();
                }}
            >
                <Grid container spacing={2}>
                    <AdminHeader title={`Cancel reason edit`} />
                    {!!error && (
                        <Grid
                            item
                            container
                            spacing={2}
                            xs={12}
                            style={{
                                color: theme.palette.error.main
                            }}
                            alignItems="center"
                        >
                            <Grid item>
                                <ErrorIcon color="error" />
                            </Grid>
                            <Grid item>
                                <span>{error.response.body.message}</span>
                            </Grid>
                        </Grid>
                    )}
                    <FormSection title="Cancel reason information">
                        <Grid item xs={12}>
                            <TextField
                                label="Name"
                                fullWidth
                                required
                                type="text"
                                value={cancelReason ? cancelReason.name : ''}
                                onChange={ev => setCancelReason({ ...cancelReason, name: ev.target.value })}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Description"
                                fullWidth
                                multiline
                                rows={4}
                                type="text"
                                value={cancelReason ? cancelReason.description : ''}
                                onChange={ev => setCancelReason({ ...cancelReason, description: ev.target.value })}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={cancelReason ? cancelReason.requires_note : false}
                                        onChange={ev => setCancelReason({ ...cancelReason, requires_note: ev.target.checked })}
                                        color="primary"
                                    />
                                }
                                label="Requires additional note when used"
                            />
                        </Grid>
                    </FormSection>
                    <Grid item xs={6}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            disabled={!cancelReason.name}
                            onClick={() => {
                                modifyCancelReason();
                            }}
                        >
                            Save
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={() => history.push(`/admin/cancelreasons`)}
                        >
                            Back
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Grid>
    );
}

export default CancelReasonsEditPage;